import { colorDecrease, colorIncrease, colorYellow } from '@/config/color';
import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => (
  {
    container: {
      height: 8,
      borderRadius: 5,
      width: '70px',
      backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
      position: 'relative',
    },
    fillPercent: {
      borderRadius: 5,
      backgroundColor: colorIncrease,
      position: 'absolute',
      height: '100%',
      top: 0,
      left: 0,
    },
    redLine: {
      position: 'absolute',
      background: colorDecrease,
      height: '20px',
      width: '2px',
      top: '-6px',
    },
    yellowFillPercent: {
      borderRadius: 5,
      backgroundColor: colorYellow,
      position: 'absolute',
      height: '50%',
      top: 0,
      left: 0,
    },
  }
));

export default useStyles;
